// src/config/api.js
// Centralized API configuration

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default API_URL;

// Usage in components:
// import API_URL from '../config/api';
// fetch(`${API_URL}/products/all`)